import { render, staticRenderFns } from "./CreateMovieView.vue?vue&type=template&id=1ba8433b&"
import script from "./CreateMovieView.vue?vue&type=script&lang=js&"
export * from "./CreateMovieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports